export default {"src":"/_next/static/media/playstore.b1e16d4d.svg","height":48,"width":163,"blurWidth":0,"blurHeight":0};